module.exports = __webpack_public_path__ + "resources/img/img_voice_studio2_en.4697bfc53fdf1edbe57cd1d8d23d908f.png";